import type { MetricDirectoryEntry } from "../hooks/useMetricDirectory"

// Prefer the instance's own description; fall back to the catalog when the
// instance is empty so list/grid views always show something meaningful.
export function resolveMetricDescription(
  entry: MetricDirectoryEntry | undefined,
  instanceDescription: string | null | undefined,
): string {
  if (instanceDescription && instanceDescription.trim().length > 0) {
    return instanceDescription
  }
  return entry?.description ?? ""
}
